<template>
  <div v-if="!hideRecommendedSearches" class="recommended-searches-widget">
    <div class="flex items-center justify-between">
      <!--<q-icon
        name="sym_r_person_search"
        size="25px"
        class="q-mr-sm"
        style="margin-top: -8px"
      />-->
      <h5 class="q-mb-sm">
        For You near
        <span
          class="--hover-secondary cursor-pointer"
          style="text-decoration: underline;"
          @click="
            () => {
              promptPostalCodeInputDialog();
            }
          "
        >
          {{ $store.getters["search/locationCityStateFormatted"] }}
        </span>
      </h5>
      <div v-if="windowWidth > 1025" class="flex items-center no-wrap">
        <q-btn
          round
          dense
          color="background-light"
          icon="sym_r_keyboard_arrow_left"
          class="--bordered --shadow__bottom q-mr-sm"
          @click="
            () => {
              triggerHorizontalScrollableScroll(id, 'left');
            }
          "
        />
        <q-btn
          round
          dense
          color="background-light"
          icon="sym_r_keyboard_arrow_right"
          class="--bordered --shadow__bottom"
          @click="
            () => {
              triggerHorizontalScrollableScroll(id, 'right');
            }
          "
        />
      </div>
    </div>
    <HorizontalScrollable
      v-if="recommendedSearches.length > 0"
      class="recommended-searches-widget__container"
      :key="id"
      :ref="id"
    >
      <div
        class="recommended-searches-widget__searches flex items-center q-gutter-xs no-wrap"
      >
        <div
          v-for="(recommendedSearch, i) in recommendedSearches"
          :key="i + '_recommendedSearch'"
        >
          <q-chip
            color="background-light"
            text-color="white"
            @mousedown="horizontalScrollClickStart"
            @mouseup="
              e => {
                horizontalScrollClickEnd(e, () => {
                  handleSearchClick(recommendedSearch);
                });
              }
            "
            @click.stop.prevent
            clickable
            class="recommended-search-chip --text-sm --shadow__bottom --bordered --hover-secondary-border"
            style="height: auto; padding: 12px 16px 11px; font-size: 0.95rem"
          >
            <div>
              <div class="flex items-center no-wrap">
                <!--<q-icon name="sym_r_search" size="20px" class="q-mr-sm" />-->
                <div class="text-weight-medium">{{ recommendedSearch }}</div>
              </div>
              <div class="flex items-center no-wrap" style="margin-top: 2px">
                <!--<q-icon name="sym_r_add_circle" size="14px" class="q-mr-xs" color="text-light" />-->
                <div
                  style="width: 6px; height: 6px; border-radius: 50%; margin-bottom: -1px; margin-right: 6px;"
                  class="bg-secondary"
                />
                <div class="text-text-light">
                  {{ Math.floor(Math.random() * (200 - 20 + 1)) + 20 }} New
                  Listings
                </div>
              </div>
            </div>
          </q-chip>
        </div>
      </div>
    </HorizontalScrollable>
    <HorizontalScrollable v-else class="recommended-searches-widget__container">
      <div
        class="recommended-searches-widget__searches flex items-center q-gutter-xs no-wrap"
      >
        <q-card
          v-for="i in 10"
          :key="i + '_recommendedSearchPlaceholder'"
          class="q-pa-none q-mr-sm"
          style="width: 240px; min-width: 240px; height: 50px; margin-left: 8px; margin-top: 8px"
          flat
        >
          <q-skeleton animation="fade" class="full-width full-height" />
        </q-card>
      </div>
    </HorizontalScrollable>
  </div>
</template>

<script>
import HorizontalScrollable from "@/components/UI/HorizontalScrollable.vue";
import axios from "axios";
import { Dialog } from "quasar";
import PostalCodeInputDialog from "@/components/PostalCodeInputDialog.vue";

export default {
  name: "RecommendedSearchesWidget",
  components: {
    HorizontalScrollable
  },
  data() {
    return {
      id: "recommendedSearchesWidget_" + Math.random() * 10000,
      recommendedSearches: [],
      hideRecommendedSearches: false,
      clickLocation: { x: 0, y: 0 }
    };
  },
  mounted() {
    this.initRecommendedSearches();
  },
  methods: {
    initRecommendedSearches() {
      axios
        .post(
          "https://api-v2.jumpfeed.com/network/publisher/carscience-search-suggestions-open-router-v2",
          {
            visitor_profile: {
              clickCounts: this.generateVisitorProfile(),
              filterCounts: this.$store.getters[
                "search/searchFiltersHistoryByClauseCount"
              ],
              filterHistory: this.$store.getters[
                "search/searchFiltersHistory"
              ].slice(0, 20)
            },
            num_suggestions: 10,
            has_previous_history:
              this.$store.state.chat.conversationHistory.length > 0 ? 1 : 0
          }
        )
        .then(response => {
          let output = response.data.data;
          output.reply.forEach(suggestion => {
            this.recommendedSearches.push(suggestion);
          });
        })
        .catch(e => {
          this.hideRecommendedSearches = true;
          console.error(e);
        });
    },
    getPreviousSearches() {
      const previousMessages = window.localStorage.getItem(
        "previous-chat-messages"
      );
      if (previousMessages) {
        try {
          return JSON.parse(previousMessages)
            .filter(message => message.fromUser)
            .map(message => message.message);
        } catch (e) {
          return [];
        }
      }
      return [];
    },
    horizontalScrollClickStart(event) {
      this.clickLocation = {
        x: event.clientX,
        y: event.clientY
      };
    },
    horizontalScrollClickEnd(event, callback) {
      let clickDragThreshold = 10;
      let deltaX = Math.abs(event.clientX - this.clickLocation.x);
      let deltaY = Math.abs(event.clientY - this.clickLocation.y);
      let wasClickOperation =
        deltaX < clickDragThreshold && deltaY < clickDragThreshold;
      if (wasClickOperation) {
        callback();
      }
    },
    handleSearchClick(searchText) {
      this.$store.commit("chat/ADD_MESSAGE", {
        fromUser: true,
        message: searchText
      });
      this.$store.commit("chat/SET_SIDEBAR", true);

      this.$store.commit("search/RESET_PAGINATION");
      this.$store.commit("search/SET_LOADING", true);
    },
    promptPostalCodeInputDialog() {
      let existingPostalCode = this.$store.state.search.location.postalCode;
      let existingRadius = this.$store.state.search.location.radius;
      Dialog.create({
        component: PostalCodeInputDialog
      }).onDismiss(() => {
        if (
          this.$store.state.search.location.postalCode != existingPostalCode ||
          this.$store.state.search.location.radius != existingRadius
        ) {
          window.location.reload();
        }
      });
    },
    triggerHorizontalScrollableScroll(refId, direction) {
      this.$refs[refId].triggerManualScroll(direction);
    }
  }
};
</script>

<style lang="scss" scoped>
.recommended-searches-widget {
  width: 100%;
  z-index: 1;

  &::-webkit-scrollbar {
    display: none;
  }

  .recommended-searches-widget__header {
    display: flex;
    align-items: center;
    justify-content: start;
  }

  .recommended-searches-widget__container {
    width: 100%;
    overflow-x: auto;
    padding: 0;
    margin-left: -6px;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .recommended-searches-widget__searches {
    position: relative;
    display: flex;
    flex-wrap: nowrap;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .recommended-search-chip {
    @include hover-scale(1.03);
    @include transition(all);
    padding-top: 6px;
    padding-bottom: 6px;

    &:hover {
      border: 1px solid color(secondary);
    }
  }
}
</style>
